import React from "react";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import style from "./style.module.css";
import PackItem from "./PackItem";
import ItemUpdateForm from '../ItemUpdateForm';
import {v4 as uuidv4} from "uuid";

@inject((store) => {
  const { myShopApiStore } = store;
  return { myShopApiStore };
})

@observer
class PackItemUpdateForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
             currentStep: this.props.myShopApiStore.stepNum ? this.props.myShopApiStore.stepNum : 1,
             stepsAmount: this.props.myShopApiStore.cartItemUpdating.steps.length,
             error: false
        }
    }

    handleAddPackItemClick = (packItem, stepNum) => {
        const { openPackItemForm,
                cartItemUpdating,
                calcTotalCartPrice,
                packItemUpdating,
                closeCartItemForm } = this.props.myShopApiStore;
        const isEditableItem = packItem.item.shopProductOptions.length || packItem.item.shopToppings.length || packItem.item.shopBaseToppings?.length;

        if(packItem.isReadyToOrder){
            // packItem.isReadyToOrder = true;
            isEditableItem && openPackItemForm(packItem);
        }
        else{
            cartItemUpdating.steps[stepNum-1].packItems.forEach(packItem => packItem.isReadyToOrder = false);
            packItem.isReadyToOrder = true;

            const isTheLastStep = this.state.stepsAmount === stepNum;
            if(isEditableItem){
                openPackItemForm(packItem);
            }
            else if(isTheLastStep){
                closeCartItemForm();
            }
            else{
                this.nextStep();;
            }

        }
        calcTotalCartPrice();
    }

    checksProductSelected = () => {
        const { steps } = this.props.myShopApiStore.cartItemUpdating;
        let isSelected = false;

        steps.forEach((step, s_idx) => {
            if(s_idx === this.state.currentStep-1){
                isSelected = step.packItems.some(p_item => p_item.isReadyToOrder);
            }
        })
        !isSelected && this.setState({error: true})
        return isSelected;
    
    }

    nextStep = () => {
        if(this.checksProductSelected()){
            this.setState({error: false});
            if(this.state.currentStep < this.state.stepsAmount){
                this.setState({currentStep: this.state.currentStep + 1})
            }
        }
    }
    prevStep = () => {
        if(this.state.currentStep > 1){
            this.setState({currentStep: this.state.currentStep - 1, error: false})
        }
    }

    renderStepBar = (stepBar) => {
        return(
            <React.Fragment key={stepBar.stepNum}>
                {stepBar.stepNum !== 1 && <>&nbsp;- -&nbsp;</>}
                <div className={style.StepBar} style={{ color: 
                                                            stepBar.stepNum === this.state.currentStep && "#5c5c5c",
                                                        border:
                                                            stepBar.stepNum === this.state.currentStep ? "1px solid #5c5c5c" :"1px solid #dcdcdc"
                                                }}>
                    {stepBar.stepNum}
                </div>
            </React.Fragment>
        )
    }

    cancleCartItem = () => { //remove init edit cart-pack-item (is not UNUPDATED cart-pack-item)
        const { closeCartItemForm, isOpenForEdit, removeCartItem, getCart } = this.props.myShopApiStore;

        closeCartItemForm()
        
        if(!isOpenForEdit){ // if its the initial edit -> remove from cart!
            const { cartItemList } = getCart();
            const idx = cartItemList.length - 1;
            removeCartItem(idx);
        }
    }

    render(){
        const { cartItemUpdating, isPackItemUpdating } = this.props.myShopApiStore;
        const { steps } = cartItemUpdating;
        const { toppingsFree } = steps[this.state.currentStep-1];

        return(
            <div className={style.Container}>
                {
                    isPackItemUpdating
                    ? <ItemUpdateForm toppingsFree={toppingsFree} checkForProductsAssociated={this.props.checkForProductsAssociated} nextStep={this.nextStep} currentStep={this.state.currentStep}/>
                    : <div>
                        <div className={style.CloseButton}>
                            <button title="סגור" onClick={this.cancleCartItem}>✕</button>
                        </div>
                        <div>
                            {
                                steps.map((step, lIdx) => {
                                    return(
                                        <div key={lIdx}>
                                            {
                                                this.state.currentStep === step.stepNum &&
                                                (<div>
                                                    <div className={style.StepDescription}>{step.description}</div>
                                                    {step.productsAmount > 1 && <div className={style.ItemNumber}>פריט מספר {step.itemNum}</div>}
                                                    <div>
                                                    <div className={style.StepsBar}>
                                                        {steps.map(this.renderStepBar)}
                                                    </div>
                                                        {step.packItems.map((packItem,pIdx) => {
                                                            return (
                                                                <div key={pIdx}>
                                                                    <PackItem 
                                                                        packItem={packItem}
                                                                        stepNum={step.stepNum}
                                                                        handleAddPackItemClick={this.handleAddPackItemClick}
                                                                    />
                                                                </div>
                                                            )

                                                        })}
                                                    </div>
                                                </div>)
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className={style.Buttons}>
                            {this.state.error && <span style={{color: '#FF0000'}}>אנא בחר פריט</span>}
                            {/* {this.state.currentStep !== this.state.stepsAmount && <button onClick={this.nextStep}>הבא</button>} */}
                            {/* {this.state.currentStep !== 1 && <button onClick={this.prevStep}>הקודם</button>} */}
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default PackItemUpdateForm;
